import { createContext, useContext } from 'react';
import type { RouterOutputs } from '@duke-hq/svc-api/provider';

export type LoginUserType = {
  username: string;
  password: string;
  otp_code: string;
  email: string;
  phone_number: string;
};

/**
 * The AuthContextType interface represents the shape of the authentication context.
 * @property user - The authenticated user object.
 * @property signOut - A function to sign out the user.
 */
export interface AuthContextType {
  user: NonNullable<RouterOutputs['me']>;
  signOut: () => Promise<void>;
  settings: {
    NEW_REFERRAL_PROCESS: boolean;
  };
}

/**
 * The AuthContext provides the authentication context to the entire provider application.
 */
export const AuthContext = createContext<AuthContextType>({} as AuthContextType);

/**
 * The useAuthTenant hook provides access to the authentication context.
 * @returns {AuthContextType} The authentication context.
 */
export function useAuthTenant(): AuthContextType {
  return useContext(AuthContext);
}
